import { useEffect } from 'react';
import { narrowToWideCompositions } from '../compositions';
import { sanatizeInteger, sanatizeBoolean } from '../helpers/util';
import { compositionToPaginationItems } from '../paginationItem';
import { useWidestComposition } from './useWidestComposition';
export function usePaginationItems(inputCurrent, inputTotal, maxWidth, options) {
    var narrowToWideCompositionsProvider = function () {
        var _a, _b, _c;
        return narrowToWideCompositions({
            current: (_a = sanatizeInteger(inputCurrent)) !== null && _a !== void 0 ? _a : 0,
            total: (_b = sanatizeInteger(inputTotal)) !== null && _b !== void 0 ? _b : 0,
            narrowStrategies: sanatizeNarrowStrategies(options === null || options === void 0 ? void 0 : options.narrowStrategy),
            renderNav: (_c = sanatizeBoolean(options === null || options === void 0 ? void 0 : options.renderNav)) !== null && _c !== void 0 ? _c : true,
        });
    };
    var _a = useWidestComposition(narrowToWideCompositionsProvider, maxWidth), compositionItems = _a.items, ref = _a.ref, clearCache = _a.clearCache;
    useEffect(function () {
        return function () { return clearCache(); };
    }, [clearCache, options === null || options === void 0 ? void 0 : options.previousLabel, options === null || options === void 0 ? void 0 : options.nextLabel]);
    var items = compositionToPaginationItems(compositionItems, options);
    return { items: items, ref: ref, clearCache: clearCache };
}
function sanatizeNarrowStrategies(inputNarrowStrategies) {
    return (Array.isArray(inputNarrowStrategies)
        ? inputNarrowStrategies
        : [inputNarrowStrategies]).filter(function (strategy) { return strategy === 'dropEllipsis' || strategy === 'dropNav'; });
}
